import { travelData } from "@escapio/portal/state/travelData";

export const matchesCurrency = deal =>
	Boolean(deal.prices?.[travelData.currency]?.price);
